<script setup>
import { ref, onMounted } from "vue";
import { messageList, unreadCount, allRead, read } from "@/api/message";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";

// 国际化工具
const { t } = useI18n();

// 当前激活的消息项
const activeNames = ref([]);

// 消息列表信息
const messageListInfo = ref([]);

// 未读消息数量
const messageCount = ref(null);

// 获取最新消息列表
const getNewMessage = () => {
  messageList().then(res => {
    if (res && res.data && res.data.list) {
      messageListInfo.value = res.data.list;
    }
  });
};

// 获取未读消息数量
const getUnreadCount = () => {
  unreadCount().then(res => {
    if (res && res.data) {
      messageCount.value = res.data;
    }
  });
};

// 将所有消息标记为已读
const handleAllRead = () => {
  allRead().then(() => {
    ElMessage({
      message: t('message.markedRead'),
      type: 'success',
    });
    getUnreadCount();
  });
};

// 标记单条消息为已读
const handleRead = (item) => {
  read({ ids: [item.id] }).then(() => {
    ElMessage({
      message: t('message.markedRead'),
      type: 'success',
    });
    getNewMessage();
  });
};

// 生命周期：组件挂载后执行
onMounted(() => {
  getNewMessage();
  getUnreadCount();
});

</script>

<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="card">
        <div class="card-header d-flex align-items-center justify-content-between">
          <div>{{$t('message.notificationMessage')}}{{messageCount}}</div>
          <el-link @click="handleAllRead">{{$t('message.allRead')}}</el-link>
        </div>
        <div class="card-body">
          <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item :title="item.templateContent.includes('\n') ? item.templateContent.split('\n')[0] : item.templateContent" name="1" v-for="(item,index) in messageListInfo" :key="index">
              <div  v-if="item.templateContent.includes('\n')" class="p-3">
                <p v-for="(it,idx) in item.templateContent.split('\n')" :key="idx">
                  {{it}}
                </p>
              </div>
              <div v-else  class="p-3">
                {{item.templateContent || '--'}}
              </div>
              <div class="p-3">
                <el-button  v-if="!item.readStatus" type="success" @click="handleRead(item)">{{$t('message.markRead')}}</el-button>
                <el-button  v-if="item.readStatus" type="info" >{{$t('message.read')}}</el-button>
              </div>

            </el-collapse-item>

          </el-collapse>
          <el-empty v-if="messageListInfo && messageListInfo.length === 0" :description="$t('home.noData')" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
